// extracted by mini-css-extract-plugin
export var hideEditor = "_mn-2";
export var infoIcon = "_mn-3";
export var label = "_mn-1";
export var labelContainer = "_mn-0";
export var readonlyText = "_mn-4";